class BlockyTimer extends HTMLElement {
  constructor() {
    super();
    this.currHours = this.getAttribute("data-hours")
    this.currMinutes = this.getAttribute("data-minutes")
    this.text = this.getAttribute("data-text")
    this.interval = setInterval(this.updateTimer.bind(this), 60000);
  }
  
  updateTimer() {
    if (this.currMinutes > 0) {
      this.currMinutes -= 1
    } else if (this.currHours > 0 ) {
      this.currHours -= 1
      this.currMinutes = 59
    }

    this.querySelector(".blocky-timer-text").innerHTML = this.text.replaceAll("[HOURS]", this.currHours).replaceAll("[MINUTES]", this.currMinutes)
    
    if (this.currHours == 0 && this.currMinutes == 0) {
      clearInterval(this.interval)
    }
  }
}
customElements.define('blocky-timer', BlockyTimer);

if (!customElements.get('blocky-video')) {
  customElements.define('blocky-video',
    class BlockyVideo extends HTMLElement {
      constructor() {
        super()
        this.video = this.querySelector("video")
        if (this.video) {
          this.video.addEventListener('waiting', this.showSpinner.bind(this));
          this.video.addEventListener('canplaythrough', this.hideSpinner.bind(this));
          this.video.addEventListener('error', this.hideSpinner.bind(this));
        }
        if (this.classList.contains("blocky-video-manual")) {
          this.video.addEventListener("click", (e) => this.onClick())
          const button = this.querySelector(".blocky-video-play-button")
          button.addEventListener("click", (e) => this.onClick())
        } else {
          if ("IntersectionObserver" in window) {
            this.observer = new IntersectionObserver(this.handleIntersection.bind(this), { root: null, rootMargin: '0px', threshold: 0.05 });
            this.observer.observe(this);
          } else {
            // Fallback for browsers that don't support IntersectionObserver
            for (const source of this.video.querySelectorAll('source[data-src]')) {
              source.setAttribute('src', source.getAttribute('data-src'));
              source.removeAttribute('data-src');
            }
            this.video.load();
          }
          this.video.addEventListener("pause", (event) => {
              if (event.target.paused) event.target.play()
          })
          this.video.addEventListener("canplay", (event) => {
              if (event.target.paused) event.target.play()
          })
        }
      }

      handleIntersection(entries) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            for (const source of this.video.querySelectorAll('source[data-src]')) {
              source.setAttribute('src', source.getAttribute('data-src'));
              source.removeAttribute('data-src');
            }
            this.video.load();
            this.video.play();
            this.observer.disconnect();
          }
        });
      }

      onClick() {
        const button = this.querySelector(".blocky-video-play-button")
        if (this.video.paused == true) {
          this.showSpinner()
          const playPromise = this.video.play()      
          playPromise.then(() => {
            this.hideSpinner()
          }).catch((error) => {
            this.hideSpinner()
          });
          this.video.classList.add("blocky-video-playing")
          button.classList.add("blocky-hidden")
        } else {
          this.video.pause()
          this.video.classList.remove("blocky-video-playing")
          button.classList.remove("blocky-hidden")
        }
      }

      showSpinner() {
        this.video.classList.add('loading');
      }
  
      hideSpinner() {
          this.video.classList.remove('loading');
      }
    }
  )
}
